import { DataTableSort } from 'studio-components';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { toHttpParams } from '../project/helpers/to-http-params';
import { ApiKey, ApiKeyCreationParams } from './api-key.model';
import { ApiKeyCrudService } from './types';

const BASE_ADMIN_URL = `${environment.apiConfig.url}/admin/api-keys`;

@Injectable()
export class AdminApiKeyService implements ApiKeyCrudService {
  constructor(private http: HttpClient) {}

  loadApiKeys(filter?: DataTableSort): Observable<ApiKey[]> {
    const params = toHttpParams(filter);

    return this.http.get<ApiKey[]>(BASE_ADMIN_URL, { params });
  }

  createApiKey(creationParams: ApiKeyCreationParams): Observable<ApiKey> {
    return this.http.post<ApiKey>(BASE_ADMIN_URL, creationParams);
  }

  revokeApiKey(apiKeyId: number): Observable<void> {
    return this.http.delete<void>(`${BASE_ADMIN_URL}/${apiKeyId}`);
  }

  getApiKeyById(apiKeyId: number) {
    return this.http.get<ApiKey>(`${BASE_ADMIN_URL}/${apiKeyId}`);
  }
}
